// extracted by mini-css-extract-plugin
export default {"hd":"HorizontalDivider_hd__5dLDP"};